import styled, { css } from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';
import Button from '@prisjakt/ui-button';
import { Tooltip as TooltipComponent } from 'src/components/tooltip-new';
import { H3Text } from '@prisjakt/ui/text/variants';

export const Tooltip = styled(TooltipComponent)`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const DisplayOptions = styled.div`
  display: grid;
  grid-column-gap: ${layout.measurements.spacing050};
  align-items: center;
  grid-auto-flow: column;
`;
export const ProductsHeader = styled.div``;

export const Wrapper = styled.main`
  margin-bottom: ${layout.measurements.spacing050};
  padding: 0 ${layout.measurements.spacing050};
`;

export const ProductList = styled.ul`
  display: flex;
  list-style: none;
`;

export const ProductListItem = styled.li`
  width: 100%;
`;

export const SidebarFilterButton = styled(Button)`
  ${media.mediumDown`
    display: none;
  `}
`;

export const SortOptions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const SortOptionsTitle = styled.span`
  font-weight: 600;
  color: ${p => p.theme.text.quaternary};
  margin-left: ${layout.measurements.spacing050};

  ${media.smallOnly`
    display: none;
  `};
`;

export const SortOptionsButton = styled(Button)`
  padding: 0;
  margin-left: ${layout.measurements.spacing050};

  ${media.mediumDown`
    margin-right: ${layout.measurements.spacing050};
  `};
`;

export const ProductCount = styled(H3Text)`
  white-space: nowrap;
  margin-right: ${layout.measurements.spacing050};
  margin-bottom: 0;
`;

export const Notice = styled.p`
  font: inherit;
  margin: ${layout.measurements.spacing200} auto;
  max-width: 40em;
`;

const LAYOUT_BUTTON_CONTAINER_PADDING = 2;

export const LayoutButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding: ${LAYOUT_BUTTON_CONTAINER_PADDING}px;
  background: ${p => p.theme.bg.tertiary};
  border-radius: ${layout.measurements.spacing025};
`;

type SearchInputProps = {
  expanded?: boolean;
  inputWidth?: string;
  iconSize: number;
};

export const SearchInput = styled.div<SearchInputProps>`
  position: relative;
  min-width: ${p => p.iconSize}px;
  display: flex;
  align-content: start;
  align-items: center;
  flex: 1;

  ${media.mediumDown`
    margin-bottom: ${layout.measurements.spacing100};
  `}
`;
export const SearchTextWrapper = styled.div<SearchInputProps>(
  props => css`
    transition: ${props.expanded
      ? 'opacity 0.1s ease-out 0.1s, width 0.25s ease-out'
      : 'opacity 0.1s ease-out, width 0.25s ease-out'};
    width: ${props.expanded
      ? props.inputWidth || '330px'
      : `${props.iconSize}px`};
    opacity: ${props.expanded ? '1' : '0'};

    ${media.mediumDown`
      margin-bottom: 0;
    `}
  `
);

type SearchInputIconProps = {
  positionAbsolute?: boolean;
  iconSize: number;
};

export const SearchInputIcon = styled.button<SearchInputIconProps>`
  ${({ positionAbsolute }) =>
    positionAbsolute
      ? css`
          position: absolute;
          right: 0;
        `
      : ''}
  height: 100%;
  width: ${p => p.iconSize}px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  &:hover {
    color: ${p => p.theme.icons.callToActionHover};
  }
`;

export const MobileWrapper = styled.div`
  display: none;

  ${media.mediumDown`
  display: grid;
  grid-gap: ${layout.measurements.spacing050};
  grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
  margin-bottom: ${layout.measurements.spacing100};
  `}
`;

export const AdvertWrapper = styled.div`
  margin: 0 -${layout.measurements.spacing050};
  background: ${p => p.theme.bg.tertiary};
`;
